import {select } from "redux-saga/effects";
import {Type} from "../../helper";

// Only Invoice
export function* copyPaymentTermsForInvoiceBill(transactionType, transaction) {
    if (![
        Type.sale_invoice, Type.sale_quote, Type.sale_order,
        Type.purchase_bill, Type.purchase_order,
    ].includes(transactionType))
        return [];

    if (transaction.payment_mode === 'cash')
        return [];

    const { contacts, settings } = yield select(state => state.List);

    const termId = transaction.term_id;
    const contact = contacts.find(contact => contact.id === transaction.contact_id);

    // If is duplicate invoice or bills, copy all term items from original
    if (transaction.term_items?.length) {
        return transaction.term_items?.map(item => ({
            term_id: item.term_id,
            payment_due: item.payment_due,
            description: item.description,
            is_recurring: false,
        }));
    }

    // If is transfer to invoice or bills, fill in with the original transaction's term or default term
    return [
        {
            term_id: (
                termId ||
                contact?.default_term_id ||
                parseFloat(settings.default_term_id) ||
                undefined
            ),
            payment_due: '100%',
            is_recurring: false,
        },
    ];
}
